<div [formGroup]="parentForm">
  <wsd-extended-input label="{{ showLabel ? (label | translate) : '' }}"
                     [control]="parentForm.get(controlName)">
    <p-autoComplete [formControlName]="controlName"
                    [suggestions]="currencies"
                    [minLength]="1"
                    field="isoCode"
                    [dropdown]="true"
                    [forceSelection]="true"
                    (completeMethod)="filterCurrencies($event)">
      <ng-template let-item pTemplate="item">
        <span>
          {{item.name + " (" + item.isoCode + ") "}}
        </span>
      </ng-template>
    </p-autoComplete>
  </wsd-extended-input>
</div>
